/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import LogRocket from 'logrocket';
import { User } from 'types';
import { SocietyCorporateId } from 'types/Society';
import { hasShowDetails } from './showDetails';

const ANONYMOUS_USER = 'anonymous_user';

export const initializeLogRocket = () => {
  LogRocket.init(process.env.REACT_APP_LOG_ROCKET_ID || '');
};

export const identifyUser = (user: Partial<User>) => {
  const corporateId =
    process.env.REACT_APP_UI_CORPORATE_ID || SocietyCorporateId.DEFAULT;

  const userData: Record<string, string> = {
    name: user?.name || '',
    email: user?.email || '',
    platform: corporateId,
  };

  LogRocket.identify(user?._id || ANONYMOUS_USER, userData);
};
